import React, { useEffect } from "react";
import "./WorldCupRules.scss";
import Menu from "../../Components/General/Menu/Menu";
import Footer from "../../Components/General/Footer/Footer";

/* Текст правил — юридический документ (promo_rules.md), воспроизведён
   ДОСЛОВНО: менять формулировки нельзя. Разрешена только вёрстка и чистка
   артефактов конвертации (двойные пробелы, «Смарт-часы  ;»). */
const WorldCupRulesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const prevTitle = document.title;
    document.title = "Правила проведения маркетинговой акции „3:0“";
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <div className="wcRules-page">
      <Menu />
      <div className="wcRules-content-container">
        <div className="wcRules-content">
          <h1>Правила проведения маркетинговой акции „3:0“</h1>

          <h2>1. ОБЩИЕ ПОЛОЖЕНИЯ</h2>
          <p>
            1.1. Настоящие Правила определяют порядок проведения маркетинговой
            акции «3:0» (далее — «Акция»), направленной на повышение лояльности
            абонентов NETS.
          </p>
          <p>
            1.2. Акция является стимулирующим маркетинговым мероприятием и{" "}
            <strong>не является лотереей</strong>, азартной игрой или иным
            основанным на риске соглашением. Участие в Акции является
            бесплатным.
          </p>
          <p>
            1.3. Организатором Акции выступает компания NETS (далее —
            «Организатор»).
          </p>
          <p>
            1.4. Призовой фонд Акции формируется за счет собственных средств
            Организатора.
          </p>

          <h2>2. УЧАСТНИКИ АКЦИИ</h2>
          <p>
            2.1. К участию в Акции допускаются дееспособные физические лица,
            достигшие <strong>18-летнего возраста</strong>, проживающие на
            территории Республики Таджикистан.
          </p>
          <p>
            2.2. Для участия необходимо пройти регистрацию на официальной
            странице Акции на сайте NETS, указав действующий номер телефона.
          </p>
          <p>
            2.3. Участвуя в Акции, Пользователь подтверждает свое согласие с
            настоящими Правилами и дает согласие на обработку своих
            персональных данных в целях проведения Акции.
          </p>

          <h2>3. МЕХАНИКА АКЦИИ</h2>
          <p>
            3.1. Для участия в Акции необходимо пройти регистрацию на сайте{" "}
            <a href="https://nets.tj">https://nets.tj</a> по номеру телефона.
          </p>
          <p>3.2. В рамках Акции Пользователям предоставляется возможность:</p>
          <ul>
            <li>
              Смотреть прямые трансляции матчей Чемпионата мира через
              внутренние ресурсы сайта NETS.
            </li>
            <li>Оставлять прогнозы на результаты матчей группового этапа.</li>
          </ul>
          <p>
            3.3. <strong>Правила прогнозирования:</strong>
          </p>
          <ul>
            <li>
              Участник имеет право зафиксировать свой прогноз на исход каждого
              отдельного матча только <strong>один раз</strong>.
            </li>
            <li>
              Участник может регистрировать прогнозы на{" "}
              <strong>каждом матче</strong> Чемпионата в рамках группового
              этапа.
            </li>
            <li>
              Использование ботов, программного обеспечения для автозаполнения
              или создание дублирующих аккаунтов запрещено. Организатор
              оставляет за собой право дисквалифицировать таких участников.
            </li>
          </ul>

          <h2>4. СИСТЕМА БАЛЛОВ И ПРИЗОВОЙ ФОНД</h2>
          <p>
            4.1. За каждый верный прогноз начисляются баллы, которые формируют
            общий рейтинг участников:
          </p>
          <ul>
            <li>
              <strong>3 балла</strong> — за угаданный точный счет матча;
            </li>
            <li>
              <strong>1 балл</strong> — за угаданную команду-победителя.
            </li>
            <li>
              <em>Примечание:</em> В случае если участник угадал точный счет,
              ему начисляется только бонус за точный счет (баллы и призы не
              суммируются).
            </li>
          </ul>
          <p>
            4.2. <strong>Ежедневные призы (сертификаты на услуги NETS):</strong>
          </p>
          <ul>
            <li>
              За верно угаданный точный счет матча — сертификат номиналом{" "}
              <strong>100 сомони</strong>.
            </li>
            <li>
              За верно угаданную команду-победителя матча — сертификат
              номиналом <strong>50 сомони</strong>.
            </li>
            <li>
              Сертификат может быть использован для оплаты услуг связи NETS,
              абонентской платы, подключения дополнительных опций, оплаты услуг
              подключения или приобретения оборудования (роутеров) при подключении.
            </li>
            <li>
              Сертификаты являются внутренним балансовым бонусом,{" "}
              <strong>обналичиванию не подлежат</strong>.
            </li>
          </ul>
          <p>
            4.3. <strong>Главные призы (по итогам группового этапа):</strong>{" "}
            По завершении группового этапа по сумме всех накопленных баллов
            определяются три победителя:
          </p>
          <ul>
            <li>1 место — Smart TV Xiaomi;</li>
            <li>2 место — Смарт-часы;</li>
            <li>3 место — Наушники Xiaomi</li>
          </ul>

          <h2>5. ОПРЕДЕЛЕНИЕ И ВЫДАЧА ПРИЗОВ</h2>
          <p>
            5.1. Победители определяются автоматически системой по итогам
            рейтинга. При равенстве баллов преимущество отдается участнику,
            набравшему баллы раньше остальных.
          </p>
          <p>
            5.2. Главные призы выдаются в офисе компании NETS при предъявлении
            документа, удостоверяющего личность (паспорт).
          </p>
          <p>
            5.3. Все налоговые обязательства, возникающие в связи с получением
            призов, победители несут самостоятельно в соответствии с
            законодательством Республики Таджикистан.
          </p>

          <h2>6. ДОПОЛНИТЕЛЬНЫЕ УСЛОВИЯ</h2>
          <p>
            6.1. Организатор вправе вносить изменения в настоящие Правила,
            уведомив об этом Участников путем публикации на сайте.
          </p>
          <p>
            6.2. Организатор не несет ответственности за сбои в работе сети
            Интернет, которые могут повлиять на корректность отображения
            трансляций или передачу данных прогнозов.
          </p>
          <p>
            6.3. В случае возникновения спорных ситуаций, решение Организатора
            является окончательным и обязательным к исполнению.
          </p>

          <p>
            <strong>
              Желаем удачи в прогнозах и яркого просмотра Чемпионата вместе с
              NETS!
            </strong>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default WorldCupRulesPage;
